const cantidades = () => {
    const formularios = Array.from(document.querySelectorAll<HTMLElement>('[class*=--formulario]'));

    formularios.forEach(formulario => {
        Array.from(formulario.querySelectorAll<HTMLElement>('.campo--cantidades')).forEach(bloque => {
            const descripcion = bloque.querySelector<HTMLElement>('.cantidades__descripcion'),
                input = bloque.querySelector<HTMLInputElement>('.cantidades__input'),
                periodicidades = Array.from(formulario.querySelectorAll<HTMLInputElement>('[data-nombre="periodicidad"] input'));

            if (!descripcion || !input) {
                return;
            }

            const radios = Array.from(bloque.querySelectorAll<HTMLInputElement>('input[type="radio"]'));

            const actualiza = (radio: HTMLInputElement, vaciar: boolean = true) => () => {
                if (vaciar) {
                    input.value = '';
                }

                if (!radio.value) {
                    radio.parentElement!.appendChild(input);
                    input.type = 'number';
                    input.required = true;
                    input.focus();
                } else {
                    input.value = radio.value;
                    input.type = 'hidden';
                }

                descripcion.innerHTML = radio.dataset.descripcion || '';
            }

            radios.forEach(radio => radio.addEventListener('change', actualiza(radio)));

            // Marcamos el radio por defecto
            radios.filter(radio => radio.checked).forEach(radio => actualiza(radio, false)());

            input.addEventListener('keyup', (e: KeyboardEvent) => {
                if (e.key === 'Escape') {
                    radios[2].checked = true;
                    radios[2].focus();
                    actualiza(radios[2])();
                }
            });

            if (periodicidades.length) {
                const actualizaInput = (periodicidad: HTMLInputElement) => {
                    radios
                        .filter(x => x.dataset.valueMensual)
                        .forEach(radio => {
                            const actualizar = input.value === radio.value;
                            radio.value = radio.dataset["value" + periodicidad.value[0].toUpperCase() + periodicidad.value.slice(1)] || '';
                            radio.previousElementSibling!.innerHTML = radio.value + '&nbsp;€';

                            if (actualizar) {
                                input.value = radio.value;
                            }
                        });

                    radios
                        .filter(x => x.dataset.minimoMensual)
                        .forEach(radio => {
                            input.min = radio.dataset["minimo" + periodicidad.value[0].toUpperCase() + periodicidad.value.slice(1)] || '';
                        });

                }

                periodicidades.forEach(periodicidad => periodicidad.addEventListener('change', (e) => {
                    const target = e.target as HTMLInputElement;
                    if (target.checked) {
                        actualizaInput(target);
                    }
                }));

                actualizaInput(periodicidades[0]);
            }
        });
    });
}

export default cantidades;